import { Injectable } from '@angular/core';
import { CustomState } from '../interface/custom-state.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { first, firstValueFrom, map } from 'rxjs';
import { DataService } from './data.service';
import { DisableOrActive } from '../interface/disableOrActive';

@Injectable({
  providedIn: 'root'
})
export class CustomStateService {

  private _isFromMatrix = true;


  constructor(
    private dataService: DataService,
    private _http: HttpClient
  ) { }

  async getAll(): Promise<CustomState[]> {
    const url = `${environment.mkgoURL}/api/v1/additional/state`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const states = await this._http.get(url, options)
      .pipe(
        first(),
        map(res => res['additionalStates'] ? res['additionalStates'] : []),
        map(res => res.sort((el1, el2) => el1.seq - el2.seq)),
        map((arr: any[]) => arr.map(obj =>  new CustomState(obj))),
      ).toPromise()
    return states
  }

  async get(id: string, ): Promise<CustomState> {
    const url = `${environment.mkgoURL}/api/v1/additional/state/${id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
     const state = await this._http.get(url, options).pipe(
        first(),
        map(obj => new CustomState(obj))
      ).toPromise()
    return state
  }

  async create(state: CustomState) {
    const url = `${environment.mkgoURL}/api/v1/additional/state`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const body = {
      additionalState: [state.toAPI()]
    }
    await this._http.post(url, body, options).pipe(first()).toPromise() // returns {}
  }

  async update(state: CustomState){
    const url = `${environment.mkgoURL}/api/v1/additional/state/${state.id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    await this._http.put(url, state.toAPI(), options).pipe(first()).toPromise()
  }


  //Budget
  async getAllBudget(): Promise<CustomState[]> {
    const url = `${environment.mkgoURL}/api/v1/additional/state`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    //options.headers.append('isBudget', "true")
    const op2 = {
      headers: options.headers,
      params: new HttpParams()
        .append('isBudget', "true")
    }

    const resp = await this._http.get(url, op2)
      .pipe(
        first(),
        map(res => res['additionalStates'] ? res['additionalStates'] : []),
        map((arr: any[]) => arr.map(obj => new CustomState(obj))),
      ).toPromise();

      // const states = resp.filter(state => )
    return resp;
  }

  async createBudget(state: CustomState) {
    state.isBudget = true;
    const url = `${environment.mkgoURL}/api/v1/additional/state`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    const body = {
      additionalState: [state.toAPI()]
    }
    await this._http.post(url, body, options).pipe(first()).toPromise() // returns {}
  }

  async updateBudget(state: CustomState){
    state.isBudget = true;
    const url = `${environment.mkgoURL}/api/v1/additional/state/${state.id}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    await this._http.put(url, state.toAPI(), options).pipe(first()).toPromise();
  }

  async getInactives(isBudget = false): Promise<CustomState[]> {
      const url = `${environment.mkgoURL}/api/v1/additional/state/inactives`;
      const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
      const op2 = {
        headers: options.headers,
        params: new HttpParams()
          .append('isBudget', isBudget)
      };

      const states = await this._http.get(url, isBudget ? op2 : options)
        .pipe(
          first(),
          map(res => res['additionalStates'] ? res['additionalStates'] : []),
          map(res => res.sort((el1, el2) => el1.seq - el2.seq)),
          map((arr: any[]) => arr.map(obj =>  new CustomState(obj))),
        ).toPromise()
      return states;
  }

  async inactiveOrActive(id: string, action: DisableOrActive){
    const url = `${environment.mkgoURL}/api/v1/additional/state/${id}/${action}`;
    const options = await firstValueFrom(this.dataService.httpOptions(this._isFromMatrix));
    await firstValueFrom(this._http.put(url, {}, options));
  }
}
